<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2">OSBOD Docent Modules</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-title>
			<v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details></v-text-field>
		</v-card-title>

		<v-data-table :headers="headers" :items="data" :search="search" :loading="loading">
			<template v-slot:top>
				<v-toolbar dark dense color="primary" flat class="mb-1">
					<v-btn depressed class="ml-2" @click="setTeacherSubjectClass()" color="inverted">
						<v-icon class="pr-2">mdi-plus-circle</v-icon>Add Module
					</v-btn>
				</v-toolbar>
			</template>
			<template v-slot:item.action="{ item }">
				<v-icon @click="handleClick(item.id)">mdi-account-edit</v-icon>
			</template>
		</v-data-table>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "teacher_subject_classs",
	data() {
		return {
			//user: localStorage.getItem("user"),
			search: "",
			headers: [
				{
					text: "",
					align: "center",
					sortable: false,
					value: "action"
				},
				{ text: "Schooljaar", value: "tbl_sys_schoolyear.name" },
				{ text: "Sector", value: "tbl_sys_sector.name" },
				{ text: "Opleiding", value: "tbl_sys_study.name" },
				{ text: "Klas", value: "tbl_sys_class.name" },
				{ text: "Periode", value: "tbl_sys_periode.name" },
				{ text: "Deelkwalificatie", value: "tbl_sys_subject.name" },
				{ text: "Module", value: "module" },
				{ text: "Docent", value: "tbl_employee.teacher_name" }
				// { text: "Module", value: "name" },
				// { text: "Omschrijving", value: "description" },
				
				// { text: "First Check", value: "firstcheckby"},
				// { text: "Second Check",	value: "secondcheckby"},
				// { text: "Active", value: "tbl_teacher_subject_class.teacher_subject_class_active" }

			],
			// semesters: [],
			// studies: [],
			// teacher_subject_classs: [],
			// teacher_subject_classtypes: [],
			// selected_teacher_subject_class: null,
			// selected_kwalificatie: null,
			// selected_deelkwalificatie: null,
			// selected_semester: null,
			// schoolyear: [],
			// selected_schoolyear: null,
			data: [],
			// banktypes: [],
			isEmpty: false,
			loading: false,
			isPaginated: true,
			isPaginationSimple: false,
			defaultSortDirection: "asc",
			currentPage: 1,
			perPage: 15
		};
	},
	created: function() {
		// this.getBanktypes();
		this.getTeacherSubjectClasss();
	},
	watch: {
		// selected_kwalificatie: function(value) {
		// 	this.getStudyTeacherSubjectClasstype(value);
		// 	console.log(value);
		// }
	},
	computed: {
		// school() {
		// 	return this.$store.getters.getSchool;
		// }
	},
	methods: {
		handleClick(id) {
			this.$router.push({
				path: "/schooladmin/teachersubjectclasscursus/update/" + id
			});
		},
		setTeacherSubjectClass: function() {
			this.$router.push({
				path: "/schooladmin/teachersubjectclasscursus/new"
			});
		},
		getTeacherSubjectClasss: function() {
			var self = this;
			this.loading = true;
			ax.get("/teacher_subject_class/all_cursus").then(function(response) {
					// console.log(response.data);
				self.data = response.data;
				console.log("TeacherSubjectClasss fetched...");
				console.log(response.data);
				self.loading = false;
			});
		},
		// getBanktypes: function() {
		// 	var self = this;
		// 	ax.get("/banktype/all").then(function(response) {
		// 		console.log(response.data);
		// 		self.banktypes = response.data;
		// 	});
		// }
	}
};
</script>
 
 <!-- Add "slot-scoped" attribute to limit CSS to this component only -->
 <style slot-scoped>
</style>